module.exports = __webpack_public_path__ + "images/feed-thanks7494504c5ad2c570eb60d02c2b0fcaf6.svg";